export default {
      id: "icon-diamond-step-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "icons.svg#icon-diamond-step",
      toString: function () {
        return this.url;
      }
    }